import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 11 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.73125 8.51182C9.35 7.69194 9.69375 6.73542 9.69375 5.64225C9.69375 2.97766 7.5625 0.791321 4.88125 0.791321C2.2 0.791321 0 2.97766 0 5.64225C0 8.30685 2.2 10.4932 4.88125 10.4932C5.98125 10.4932 7.0125 10.1516 7.76875 9.53666L9.83125 11.5864C9.96875 11.723 10.175 11.7913 10.3125 11.7913C10.45 11.7913 10.6562 11.723 10.7937 11.5864C11.0687 11.3131 11.0687 10.9031 10.7937 10.6298L8.73125 8.51182ZM4.88125 9.0584C2.95625 9.0584 1.375 7.5553 1.375 5.64225C1.375 3.72921 2.95625 2.15778 4.88125 2.15778C6.80625 2.15778 8.3875 3.72921 8.3875 5.64225C8.3875 7.5553 6.80625 9.0584 4.88125 9.0584Z",
		fill: "var(--color, #5F7691)"
	})
});
export default SvgSearch;
